module.exports = __webpack_public_path__ + "media/images/emblems/Eischoll-coat_of_arms-1dff361d15ac332692989183ff67f591.svg";